<template>
  <el-container>
    <el-header>
      <div class="h-left">
        <el-form class="form" ref="form" :model="form" label-width="120px">
          <el-form-item label="选择楼栋：" class="form-item">
            <el-select v-model="form.type">
              <el-option label="所有楼栋" value="0"></el-option>
              <el-option label="A座" value="1"></el-option>
              <el-option label="B座" value="2"></el-option>
              <el-option label="C座" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择楼层：" class="form-item">
            <el-input type="text" v-model="form.msg"></el-input>
          </el-form-item>
          <el-form-item label="设备编号：" class="form-item">
            <el-input type="text" v-model="form.statue"></el-input>
		  </el-form-item>
		  <el-form-item class="form-item">
				<!-- <div class="h-right"> -->
					<el-button type="primary" size="mini" style="margin-right: 10px;"> 查询</el-button>
				<!-- </div> -->
		  </el-form-item>
        </el-form>
      </div>
      <!-- <div class="h-right">
        <el-button type="primary" size="mini" style="margin-right: 10px;"> 查询</el-button>
      </div> -->
    </el-header>
    <el-main :style="`height:${treeHeight}px;`">
      <div class="list" style="width: 32%;float: left;" v-for="(item,index) in tableData" :key="index">
        <h3 style="padding: 10px;">{{item.DeviceName}}</h3>
        <div class="li-info" style="display: flex;flex-direction: row;" @click="handleClick(item)">
          <div class="li-left">
            <img :src="item.img" alt="">
            <span>{{item.stateName}}</span>
          </div>
          <div class="li-left" v-if="item.line==2">
            <img src="../../../public/static/vince/images/paishui/double.png" alt="">
          </div>
          <div v-if="item.line==1" style="width: 120px;float: left;">
            <img src="../../../public/static/vince/images/paishui/single.png" alt=""
              style="width:120px;height:1px;margin-top: 68px;">
          </div>

          <div class="li-right" v-if="item.line==2">
            <div style="margin-top:0rem;">
              <img src="../../../public/static/vince/images/paishui/dopen.svg" alt="">
              <p class="r-msg" style="background: #00BFA5;"> 开启</p>
            </div>
            <div style="margin-top: 5.5rem;">
              <img src="../../../public/static/vince/images/paishui/dopen.svg" alt="">
              <p class="r-msg" style="background: #00BFA5;"> 开启</p>
            </div>
          </div>

          <div class="li-right" v-if="item.line==1&&item.status==1">
            <div style="margin-top:2.5rem;">
              <img src="../../../public/static/vince/images/paishui/dopen.svg" alt=""
                style="width:40px;height:40px;margin-top: 0rem;">
              <p class="r-msg" style="background: #00BFA5;"> 开启</p>
            </div>
          </div>

          <div class="li-right" v-if="item.line==1&&item.status==0">
            <div style="margin-top:2.5rem;">
              <img src="../../../public/static/vince/images/paishui/dclose.svg" alt=""
                style="width:40px;height:40px;margin-top: 0rem;">
              <p class="r-msg" style="background: #a9a9a9;">--</p>
            </div>
          </div>

        </div>
      </div>
    </el-main>

    <el-dialog title="水泵" :visible.sync="dialogVisible" width="600px" :close-on-click-modal='false' center>
      <div style="float: left;">
        <img width="180px" :src="dialogData.img" alt="">
      </div>
      <div v-if="dialogData.line==2" class="device_detail">
        <span>设备编号：{{dialogData.DeviceName}}</span>
        <span>位置：D座B3F</span>
        <span>一号泵机是否开启：开启</span>
        <span>二号泵机是否开启：开启</span>
        <span>一号泵机是否故障：正常</span>
        <span>二号泵机是否故障：正常</span>
        <span>高水位报警：{{dialogData.stateName}}</span>
      </div>
      <div v-else class="device_detail">
        <span>设备编号：{{dialogData.DeviceName}}</span>
        <span>位置：D座B3F</span>
        <span>是否开启: --</span>
        <span>是否故障：--</span>
        <span>高水位报警：{{dialogData.stateName}}</span>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
  export default {
    data() {
      return {
        treeHeight: "",
        dialogVisible: false,
        form: {
          msg: "",
          type: "",
          statue: ""
        },
        dialogData: {},
        tableData: [{
          DeviceName: 'A20-B3WL4',
          img: require('../../../public/static/vince/images/paishui/dalarm.svg'),
          line: 2,
          status: 1,
          stateName: '告警',
          remark: '在线'
        }, {
          DeviceName: 'A25-B6WL2',
          img: require('../../../public/static/vince/images/paishui/dnormal.svg'),
          line: 1,
          status: 0,
          stateName: '正常',
          remark: '离线'
        }, {
          DeviceName: 'A25-B6WL2',
          img: require('../../../public/static/vince/images/paishui/dnormal.svg'),
          line: 2,
          status: 0,
          stateName: '正常',
          remark: '离线'
        }, {
          DeviceName: 'A25-B6WL2',
          img: require('../../../public/static/vince/images/paishui/dalarm.svg'),
          line: 1,
          status: 1,
          stateName: '告警',
          remark: '在线'
        }, {
          DeviceName: 'A25-B6WL2',
          img: require('../../../public/static/vince/images/paishui/dnormal.svg'),
          line: 1,
          status: 1,
          stateName: '正常',
          remark: '离线'
        }, {
          DeviceName: 'A25-B6WL2',
          img: require('../../../public/static/vince/images/paishui/dalarm.svg'),
          line: 1,
          status: 0,
          stateName: '告警',
          remark: '离线'
        }, ]
      }
    },
    methods: {
      handleClick(item) {
        this.dialogVisible = true;
        this.dialogData = item;
      }
    },
    mounted() {
      window.onresize = () => {
        this.treeHeight = document.documentElement.clientHeight - 157;
      }
      this.treeHeight = document.documentElement.clientHeight - 157;
    }
  }

</script>
<style scoped>
  .li-left img {
    width: 120px;
    height: 94px;
    margin-top: 25px;
  }

  .li-left span {
    font-size: 16px;
    color: #fff;
    letter-spacing: 0;
    display: block;
    height: 2rem;
    width: 120px;
    text-align: center;
  }

  .li-right {
    text-align: left;
    float: left;
    width: 13rem;
    padding-left: 1rem;
  }

  .li-right img {
    width: 40px;
    height: 40px;
    float: left;
  }

  .r-msg {
    margin: 15px;
    border-radius: 8px;
    width: 48px;
    height: 20px;
    text-align: center;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    float: left;
  }
  .r-msg:hover{
	cursor: pointer;
  }
</style>